import {
  computed,
  IObservableArray,
  makeAutoObservable,
  observable,
} from "mobx";
import LearningPathServerClient from "../../ServerClients/LearningPathServerClient";
import { LearningPathResponseApi } from "../../DTO/ServerResponseType/LearningPath/LearningPath";

import { LearningPathStore } from "./LearningPathStore";

export class LearningPathsStore {
  learningPathStores: IObservableArray<LearningPathStore> = observable.array(
    []
  );

  constructor() {
    makeAutoObservable(this);
  }

  addLearningPathAsync = async (learningPath: LearningPathResponseApi) => {
    let newStore = new LearningPathStore();
    newStore.setLearningPath(learningPath);
    return newStore.saveLearningPathAsync().then(() => {
      this.learningPathStores.splice(0, 0, newStore);
    });
  };

  public setLearningPaths = (learningPaths: LearningPathResponseApi[]) => {
    this.learningPathStores.replace(
      Array.from(learningPaths, (learningPath) => {
        let learningPathStore = new LearningPathStore();
        learningPathStore.setLearningPath(learningPath);
        return learningPathStore;
      })
    );
  };

  @computed get sortedLearningPathStores(): LearningPathStore[] {
    return this.learningPathStores.slice().sort((el1, el2) => {
      return el1.learningPath.learningPathName.localeCompare(
        el2.learningPath.learningPathName
      );
    });
  }

  deleteLearningPathAsync = async (learningPathId: string) => {
    return LearningPathServerClient.sendToDeleteLearningPathAsync(
      learningPathId
    ).then(() => {
      this.learningPathStores.replace(
        this.learningPathStores.filter(
          (learningPathStore: LearningPathStore) =>
            learningPathStore.learningPath.learningPathId !== learningPathId
        )
      );
    });
  };

  public loadAllLearningPathsWithResourcesAndModulesAsync = async (): Promise<
    LearningPathResponseApi[] | never
  > => {
    return LearningPathServerClient.sendToGetAllLearningPathsWithResourcesAndModulesAsync().then(
      (learningPaths) => {
        this.setLearningPaths(learningPaths);
        return learningPaths;
      }
    );
  };
}
